import { useState, useEffect } from "react";
import FormGenerator from "../../core/form-generator";
import {
    getEnrollmentFormRequestRow1,
    getEnrollmentFormRequestRow2,
    getEnrollmentFormRequestRow3,
    getEnrollmentFormRequestRow4,
    getEnrollmentFormRow1,
    getEnrollmentFormRow2,
    getEnrollmentFormRow3,
    getEnrollmentFormRow4,
} from "./helper";
import "./index.scss";
import { Button } from "@mui/material";
import { handleFormValidation } from "../../utils";
import { useNavigate } from "react-router-dom";

const TrainingEnrollmentForm = ({ startDate, endDate, courseId }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        courseStartDate: startDate,
        courseEndDate: endDate,
    });
    const [errors, setErrors] = useState({});
    const [isPreviewForm, setIsPreviewForm] = useState(false);
    const [formRows, setFormRows] = useState([]);

    useEffect(() => {
        const rows = courseId
            ? [
                  getEnrollmentFormRow1(),
                  getEnrollmentFormRow2(startDate, endDate),
                  getEnrollmentFormRow3(),
                  getEnrollmentFormRow4(),
              ]
            : [
                  getEnrollmentFormRequestRow1(),
                  getEnrollmentFormRequestRow2(),
                  getEnrollmentFormRequestRow3(),
                  getEnrollmentFormRequestRow4(),
              ];
        setFormRows(rows);
    }, [courseId, startDate, endDate]);

    const submitEnrollmentForm = () => {
        const isValid = handleFormValidation(
            formRows.flat(),
            setErrors,
            formData
        );

        if (isValid) {
            navigate("/oem/training/training-enrollment-list", {
                state: { ...formData, courseId },
            });
            setIsPreviewForm(true);
        }
    };

    return (
        <div className="enrollment-form-container">
            {!isPreviewForm && (
                <div>
                    {formRows.map((row, index) => (
                        <div key={index} className={`enrollment-row-${index + 1}`}>
                            <FormGenerator
                                config={row}
                                formData={formData}
                                setFormData={setFormData}
                                errors={errors}
                                setErrors={setErrors}
                            />
                        </div>
                    ))}
                    <div className="enroll-submit-btn">
                        <Button
                            variant="contained"
                            onClick={submitEnrollmentForm}
                        >
                            Enroll Now
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TrainingEnrollmentForm;
